import styled from 'styled-components';
import { colors } from '../colors';

interface bredcrumbListItemProps {
	active?: boolean;
	bredcrumbListItemNavigation?: boolean;
	selected?: boolean;
	flexDirectionColumn?: boolean;
	dFlex?: boolean;
}
const BredcrumbListItem = styled.li<bredcrumbListItemProps>`
	margin: 0px;
	list-style: none;
	padding: 0px;
	display: flex;
	font-size: 12px;
	line-height: 14px;
	color: ${colors.Grey};
	position: relative;
	padding-right: 10px;
	margin-right: 14px;
	align-items: flex-start;
	:after {
		content: '\\e905';
		position: absolute;
		right: -4px;
		top: 1px;
		color: ${colors.Grey8};
		font-size: 7px;
		font-family: 'iconFont' !important;
	}
	a {
		color: ${colors.Grey};
		font-size: 12px;
		text-decoration: none;
		cursor: pointer;
		line-height: 14px;
		transition: ease-in all 0.4s;
		:hover {
			color: ${colors.BlueDark};
		}
	}
	${({ active }) =>
		active &&
		`:after{ display: none; }
		font-family:'RubikRegular';
		color: ${colors.GreyA2};
		:last-child{
			:after{ display: none; }
		}
	`}
	${({ flexDirectionColumn }) =>
		flexDirectionColumn &&
		`flex-direction: column!important;
	`}
	${({ dFlex }) =>
		dFlex &&
		`display: flex!important;
	`}
	${({ bredcrumbListItemNavigation }) =>
		bredcrumbListItemNavigation &&
		`margin: 0px;
		list-style: none;
		padding: 0px;
		display: inline-block;
		font-size: 16px;
		line-height: 19px;
		color: ${colors.Grey58};
		position: relative;
		padding-right: 20px;
		margin-right: 36px;
		:after {
			content: '\\e90a';
			position: absolute;
			right: -16px;
			top: 1px;
			color: ${colors.Grey8};
			font-size: 16px;
			font-family: 'iconFont' !important;
		}
		a {
			color: ${colors.Grey58};
			font-size: 16px;
			line-height: 19px;
			text-decoration: none;
			cursor: pointer;
			transition: ease-in all 0.4s;
			:hover {
				color: ${colors.BlueDark};
			}
		}
		:last-child{
			:after{ display: none; }
		}
	`}
	${({ selected }) =>
		selected &&
		`font-family:'RubikMedium';
		color: ${colors.Black};
		a {
			color: ${colors.Black};
			:hover {
				color: ${colors.Black};
			}
		}
	`}
`;

export default BredcrumbListItem;
